import { styled } from 'styled-components';
import FirstTableItem from '../../components/Table/FirstTableItem';
import TableItem from '../../components/Table/TableItem';
import { ReactComponent as DetailsIcon } from '../../assets/icons/details.svg';
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron-left.svg';

export const Chevron = styled(ChevronIcon)`
  transition: all 0.2s ease-in-out;
  transform: ${props => (props.$open ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;
export const Details = styled(DetailsIcon)`
  cursor: pointer;
`;
export const TableBodyRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  display: flex;
  width: 100%;
  background-color: ${props => props.$active && '#48488815'};

  cursor: ${props => (props.$offClick ? 'default' : 'pointer')};

  min-height: 6.4rem;
  transition: all 0.2s ease-in-out;
  gap: 4rem;

  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    background-color: ${props => (props.$offClick ? 'none' : '#48488815')};
  }
  &:nth-child(even) {
    background-color: ${props => (props.$hover ? 'none' : '#48488810')};
  }
`;

export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
`;

export const LastTableItem = styled(TableItem)`
  padding-right: 16px;
  justify-content: flex-end;
  justify-content: center;
  /* background-color: red; */
  z-index: 10;
  cursor: pointer;
  &:active {
    opacity: ${props => (props.$offClick ? 1 : 0)};
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  user-select: none;
  outline: none;

  color: #fff;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  border-radius: 1.5rem;
  background-color: ${props => (props.$accepted ? '#4CA953' : '#484888')};
  height: 4rem;
  cursor: pointer;
  width: fit-content;
  min-width: 14rem;
  padding: 0.5rem 1.5rem;
  box-shadow: 0px 5px 10px #48488850;
  transition: all 0.3s ease-in-out;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: flex-start;
`;
export const RowInput = styled(Row)`
  justify-content: space-between;
  width: 700px;
  align-items: center;
`;

export const StyledRowInput = styled(RowInput)`
  width: 50rem;
  height: 53px;

  opacity: ${props => (props.$opacity ? 1 : 0.5)};

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 1.2rem;
    height: unset;
    width: 100%;
    justify-content: center;
  }
`;
export const ChevronLeft = styled(ChevronIcon)`
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.$disabled ? 0.65 : 1)};
`;

export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: 0.5rem;
  font-size: 2rem;
  cursor: pointer;
  align-items: center;
  user-select: none;
  font-family: 'Avenir-Heavy';
  display: flex;
  color: #484888;
`;
export const Value = styled.span`
  color: ${props => (props.$disabled ? 'gray' : '#484888')};
  user-select: none;
  font-family: 'Avenir';
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  @media (max-width: 875px) {
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;
export const RowValue = styled(Column)`
  flex-direction: row;
  align-items: center;
  margin-top: -7px;
  width: 272px;

  justify-content: space-between;
  @media (max-width: 350px) {
    width: 100%;
  }
`;
export const StyledRowInputValue = styled(StyledRowInput)`
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 45px;
  height: unset;

  @media (max-width: 875px) {
    align-items: center;
  }
`;

export const Text = styled.span`
  color: #484888;
  font-family: 'Avenir';
  user-select: none;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
  min-width: fit-content;
`;

export const DropDown = styled.div`
  border-radius: 15px;
  border: 1px solid #484888;
  border-bottom-right-radius: ${props => (props.$open ? 0 : 15)};
  border-bottom-left-radius: ${props => (props.$open ? 0 : 15)};
  background: #fff;
  z-index: 1000;
  width: 272px;
  height: 53px;
  transition: all 0.2s ease-in-out;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0px 5px 0px 20px;
  color: #000;
  font-family: 'Avenir';
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const DropDownMenu = styled.div`
  border-radius: 15px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  position: absolute;
  border: 1px solid #484888;
  border-top: unset;
  background: #fff;
  width: 272px;
  max-height: 318px;
  overflow: hidden;
  z-index: 2;
`;

export const StyledDropDownMenu = styled.div`
  width: 100%;
  max-height: 318px;
  height: 100%;
  padding: 10px 20px 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
`;

export const Relative = styled.div`
  position: relative;
`;

export const DropDownValue = styled.span`
  color: rgb(0, 0, 0);
  font-family: 'Avenir';
  font-size: 20px;
  font-style: normal;
  user-select: none;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const Attributes = styled(DropDownValue)`
  color: black;
  cursor: pointer;
  padding-left: 10px;
  border-radius: 15px;
  &:hover {
    background: #48488822;
  }
`;

export const MessageContainer = styled.div`
  border-radius: 3rem;
  border: 1px solid #b1b1b1;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  gap: 3rem;
  width: fit-content;
  padding: 3rem;
  flex-direction: column;
`;

export const SuccessImg = styled.img`
  width: 10rem;
  height: 10rem;
`;
export const MessageTitle = styled.span`
  color: #454584;
  text-align: center;
  font-family: 'FrankfurterEF-Medium';
  font-size: 50px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const MessageSubtitle = styled.span`
  color: #454584;
  text-align: center;
  font-family: 'Avenir-Light';
  font-size: 18px;
  letter-spacing: -0.178px;
`;
